export const init = (URL, address, mediaID, liveID, cb) => {
    const socket = new WebSocket(URL);

    socket.onopen = () => {
        socket.send(JSON.stringify({
            bcAccountAddress: address,
            mediaSpace: mediaID,
            liveStream: liveID,
        }));
        cb(null, null, socket);
    };

    socket.onerror = (event) => {
        cb(event, null, null);
    };

    socket.onclose = (event) => {
        cb(null, event, null);
    };
};

export const initLiveStream = (URL, liveStreamID, clientID, cb) => {
    const socket = new WebSocket(URL);

    socket.onopen = () => {
        socket.send(JSON.stringify({
            type: 'host_live_stream',
            liveStreamId: liveStreamID,
            clientId: clientID,
        }));
        cb(null, null, socket);
    };

    socket.onerror = (event) => {
        cb(event, null, null);
    };

    socket.onclose = (event) => {
        cb(null, event, null);
    };
};

export const initAssetEncoding = (URL, address, assetId, cb) => {
    const socket = new WebSocket(URL);

    socket.onopen = () => {
        socket.send(JSON.stringify({
            bcAccountAddress: address,
            assetId: assetId,
        }));
        cb(null, null, socket);
    };

    socket.onerror = (event) => {
        cb(event, null, null);
    };

    socket.onclose = (event) => {
        cb(null, event, socket);
    };
};
